__turbopack_context__.v({
  "wrapper": "index-module-scss-module__UeYZxG__wrapper",
  "wrapper__actions": "index-module-scss-module__UeYZxG__wrapper__actions",
  "wrapper__error": "index-module-scss-module__UeYZxG__wrapper__error",
  "wrapper__logo": "index-module-scss-module__UeYZxG__wrapper__logo",
  "wrapper__message": "index-module-scss-module__UeYZxG__wrapper__message",
  "wrapper__title": "index-module-scss-module__UeYZxG__wrapper__title",
});
